var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar_padding"},[_c('div',{staticClass:"pa-3",staticStyle:{"padding-bottom":"17px!important"}},[_c('v-btn',{staticClass:"danger_btn",attrs:{"block":"","depressed":"","large":""},on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$tr("menu", "key_5"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }